<!--
  관리자 설정
  관리자/그룹 편집 > 계정보안설정(그룹)

-->
<template>
<div>
  <div class="content-group">
    <div class="contents-row">

      <div class="portlet">
        <table class="bs-table table-bordered-none">
          <colgroup>
            <col width="320px"/>
            <col width="auto"/>
          </colgroup>
          <tbody>
            <tr>
              <td class="td-head">{{$t('sm.deviceConfig_deviceGroupConfig_parentGroupName')}} <span class="textR">*</span></td>
              <td>
                <div class="inline-group">
                  <q-input v-model="adminGeneral.parent_admin_name" class="bs bs-q-input bs-q-input-default" style="width:100%;"  disable>
                  </q-input>
                </div>
              </td>
            </tr>
            <tr>
              <td class="td-head">{{$t('cmn.name')}} <span class="textR">*</span></td>
              <td>
                <div class="inline-group">
                  <q-input v-model="adminGeneral.admin_name"
                           :disable="isReadOnly || isReadOnlyGroup"
                           name="admin_name"
                           data-vv-scope="group"
                           :maxLength="32"
                           v-validate="`required|isValidNameLenth:${2},${32}`"
                           :error="errors.has('group.admin_name')"
                           class="bs bs-q-input bs-q-input-default" style="width:100%;">
                    <tool-tip minLength="2" maxLength="32" />
                  </q-input>
                </div>
              </td>
            </tr>
            <tr>
              <td class="td-head">{{ $t('cmn.description') }}</td>
              <td>
                <div class="inline-group">
                  <q-input v-model="adminDetail.admin_desc" :disable="isReadOnly" class="bs bs-q-input bs-q-input-default" style="width:100%;">
                  </q-input>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  const { mapState } = createNamespacedHelpers('system/adminSettings/adminGroupSettings')

  export default {
    name: 'AdminGeneralGroup',
    props: {
      isReadOnly: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapState([
        'adminGeneral',
        'adminDetail'
      ]),
      isReadOnlyGroup () {
        return [1, 2].indexOf(this.adminGeneral.admin_id) !== -1 || this.adminGeneral.admin_type !== 0
      }
    }
  }
</script>

